
import 'three/examples/js/loaders/PLYLoader';

import FileTypes from '../FileTypes';
import BaseController from './BaseController';

import EMFPath from '../EMFPath';
import EMFMesh from '../gh/geometry/EMFMesh';

const unit = 1e-3;

export default class PlyController extends BaseController {
  get fileType () {
    return FileTypes.PLY;
  }

  get sliders () {
    return [];
  }

  get toggles () {
    return [];
  }

  get valueLists () {
    return [];
  }

  get exportComponents () {
    // let groups = this.groups.filter((group) => group.root.vertices.length < 120)
    // return groups.map((group, idx) => {

    let thickness = this.materialThickness;

    return this.groups.map((group) => {
      let path = new EMFPath('', '', 1);
      path.setExPath(group.root.vertices.map((v) => { return { x: v[0], y: v[1] }; }));
      group.children.forEach((child) => {
        path.addInPath(child.vertices.map((v) => { return { x: v[0], y: v[1] }; }));
      });
      path.thickness = thickness;
      return {
        paths: [ path ]
      };
    });
  }

  update (ui) {
  }

  centerize (meshes) {
  }

  parse (data, report = true) {
    this.reset();

    const loader = new THREE.PLYLoader();
    const buffer = loader.parse(data);
    const geometry = new THREE.Geometry();
    geometry.fromBufferGeometry(buffer);
    const mesh = new EMFMesh(geometry);
    mesh.setMaterial(this.materialType);
    mesh.setTextures(Object.values(this.textures)[0]);
    mesh.castShadow = true;
    const bb = geometry.boundingBox;

    const center = new THREE.Vector3();
    const size = new THREE.Vector3();
    bb.getCenter(center);
    bb.getSize(size);

    center.multiplyScalar(-unit);
    size.multiplyScalar(-unit);
    const angle = -Math.PI * 0.5;
    center.applyAxisAngle(new THREE.Vector3(1, 0, 0), angle);
    size.applyAxisAngle(new THREE.Vector3(1, 0, 0), angle);
    mesh.position.copy(center.add(new THREE.Vector3(0, -size.y * 0.5, 0)));
    mesh.scale.set(unit, unit, unit);
    mesh.rotation.set(angle, 0, 0);
    this.container.add(mesh);

    this.boundingBox.update(this.container);
    this.updateGrid();
  }

  load (path, report, onLoad, onProgress, onError) {
    const loader = new THREE.FileLoader();
    loader.load(
      path,
      (text) => {
        this.parse(text, report);
        if (onLoad !== undefined) {
          onLoad(this);
        }
      },
      onProgress, onError
    );
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/controllers/PlyController.js